var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateAccountTextBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 55,
    viewBox: "0 0 166 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 0C12.2677 0 5.99969 6.26801 5.99969 14V32C5.99969 33.7768 6.33069 35.4763 6.93438 37.0402L0.189955 51.7827C-0.621658 53.5568 1.3273 55.3243 3.0139 54.3437L17.6912 45.8106C18.4422 45.9352 19.2134 46 19.9997 46H152C159.732 46 166 39.732 166 32V14C166 6.26801 159.732 0 152 0H19.9997Z",
    fill: "#E7D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccountTextBg);
export default __webpack_public_path__ + "static/media/create_account_text_bg.023b8e84c6ef587a86cbd536cfd56c63.svg";
export { ForwardRef as ReactComponent };